/**
 * Tenant Management Banner
 * Shows when platform admin is managing another tenant
 */

import React from 'react';
import { useTenant } from '../../contexts/TenantContext';


const TenantManagementBanner: React.FC = () => {
  const { activeTenant, isManagingOtherTenant, switchBackToOwnTenant } = useTenant();

  if (!isManagingOtherTenant || !activeTenant) {
    return null;
  }

  return (
    <div className="bg-warning-light border-b border-warning/30 px-6 py-2.5">
      <div className="max-w-screen-xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="text-lg">🔧</span>
          <span className="text-label font-medium text-warning-dark">
            <strong>Managing:</strong> {activeTenant.name}
            {activeTenant.domain && <span className="opacity-70"> ({activeTenant.domain})</span>}
          </span>
        </div>
        <button type="button" onClick={switchBackToOwnTenant}
          className="px-3 py-1.5 bg-warning text-white text-label font-semibold rounded-md hover:opacity-90 transition-opacity duration-fast whitespace-nowrap">
          Switch Back to My Tenant
        </button>
      </div>
    </div>
  );
};

export default TenantManagementBanner;

